export const ADD_SALARY = "ADD_SALARY";
export const ADD_SALARY_SUCCESSFUL = "ADD_SALARY_SUCCESSFUL";
export const ADD_SALARY_FAILED = " ADD_SALARY_FAILED";